import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = "G-41GM30562T";

function injectGAScript(callback) {
  // Prevent duplicate script injection
  if (document.getElementById("ga-script")) {
    callback && callback();
    return;
  }
  const script = document.createElement("script");
  script.id = "ga-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);
    callback && callback();
  };
  script.onerror = () => {
    console.error("Failed to load Google Analytics script");
  };
  document.head.appendChild(script);
}

export default function Analytics({ referrer }) {
  const location = useLocation();

  useEffect(() => {
    injectGAScript();
  }, []);

  useEffect(() => {
    let sent = false;
    function sendPageView() {
      if (window.gtag && !sent) {
        window.gtag('event', 'page_view', {
          page_path: location.pathname + location.search + location.hash,
          referrer: referrer || document.referrer,
        });
        sent = true;
      }
    }
    if (window.gtag) {
      sendPageView();
    } else {
      const timer = setInterval(() => {
        if (window.gtag) {
          sendPageView();
          clearInterval(timer);
        }
      }, 200);
      return () => clearInterval(timer);
    }
  }, [location, referrer]);

  return null;
}
